<app-logo></app-logo>

<div class="page-header">{{'IOFFER.OFFER.OFFER_NUMBER' | translate : {number: offer.number} }}</div>

<app-output [label]="'CONTRACT_DATE_PLACE' | translate">
    {{ offer.statusDate | lsnDate }}, {{ offer.additionalData.location }}
</app-output>

<!-- produkty -->
<app-clients-summary-box [document]="offer$ | async"
                         [readonly]="true">
</app-clients-summary-box>

<div class="separator double"></div>

<app-alert alertType="info">
    {{ 'IOFFER.CHECK_DATA_INFO' | translate }}
</app-alert>

<app-property-summary-box [document]="offer$ | async"
                          [fullInsuranceDate]="false"
                          [previewEnabled]="false"
                          [iOffer]="true"
                          [type]="summaryType.OFFER"
                          [readonly]="true">
</app-property-summary-box>

<div class="separator"></div>

<app-motor-summary-box [document]="offer$ | async"
                       [fullInsuranceDate]="false"
                       [previewEnabled]="false"
                       [iOffer]="true"
                       [type]="summaryType.OFFER"
                       [readonly]="true">
</app-motor-summary-box>

<div class="separator double"></div>

<div class="box" *ngIf="offer.premium !== null">
    <div class="box-body">
        <div class="row no-gutters">
            <div class="col"></div>
            <div class="col-size">
                <div class="text-price">
                    <div class="item-text">{{'OFFER_CONFIG.TOTAL_PREMIUM' | translate}}</div>
                    <div class="item-price">{{ offer.premium | premium }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="separator"></div>

<app-alert alertType="info" class="mt-40">
    <span [innerHTML]="'IOFFER.CLAUSES.INFO.CHECKBOX_NOT_CHECKED' | translate"></span>
</app-alert>

<app-clauses [offer]="offer"
             [readonly]="true">
</app-clauses>

<div class="mt-40 text-right">
    <button class="btn btn--secondary btn--block-mobile"
            (click)="cancel()">{{'OFFER.REJECT_OFFER' | translate}}</button>
    <button class="btn btn--primary btn--block-mobile"
            (click)="accept()">{{'OFFER.ACCEPT_OFFER' | translate}}</button>
</div>


